(function () {
  function initializeProduct360() {
    var stage = document.querySelector('[data-mj-product-360]');
    if (!stage || stage.dataset.initialized === 'true') return;

    var wrapper = stage.closest('.mj-main-img-wrap');
    var mainImage = wrapper && wrapper.querySelector('#mj-main-img');
    var frameImage = stage.querySelector('[data-mj-360-frame]');
    var frameData = stage.querySelector('[data-mj-360-frames]');
    var trigger = document.querySelector('[data-mj-360-trigger]');
    if (!wrapper || !mainImage || !frameImage || !frameData || !trigger) return;

    var frameUrls;
    try {
      frameUrls = JSON.parse(frameData.textContent);
    } catch (error) {
      return;
    }
    if (!Array.isArray(frameUrls) || frameUrls.length === 0) return;

    var currentFrame = 0;
    var startFrame = 0;
    var startX = 0;
    var dragging = false;
    var active = false;
    var userInteracted = false;
    var inViewport = true;
    var autoplayTimer = 0;
    var framesPreloaded = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function showFrame(nextFrame) {
      currentFrame = ((nextFrame % frameUrls.length) + frameUrls.length) % frameUrls.length;
      frameImage.src = frameUrls[currentFrame];
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = 0;
    }

    function startAutoplay() {
      if (
        autoplayTimer ||
        !active ||
        userInteracted ||
        reducedMotion.matches ||
        document.hidden ||
        !inViewport
      ) return;

      autoplayTimer = window.setInterval(function () {
        showFrame(currentFrame + 1);
      }, 120);
    }

    function selectThumbnail(button) {
      var thumbnails = button.parentNode && button.parentNode.querySelectorAll('button');
      if (!thumbnails) return;

      thumbnails.forEach(function (thumbnail) {
        thumbnail.classList.replace('border-primary', 'border-transparent');
      });
      button.classList.replace('border-transparent', 'border-primary');
    }

    function schedulePreload(callback) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 250 });
      } else {
        window.setTimeout(callback, 16);
      }
    }

    function preloadFrames() {
      if (framesPreloaded) return;
      framesPreloaded = true;
      var index = 1;

      function loadNext() {
        if (index >= frameUrls.length) return;
        var preload = new Image();
        preload.src = frameUrls[index++];

        if (typeof preload.decode === 'function') {
          preload.decode().catch(function () {}).finally(function () {
            schedulePreload(loadNext);
          });
        } else {
          preload.onload = preload.onerror = function () {
            schedulePreload(loadNext);
          };
        }
      }

      schedulePreload(loadNext);
    }

    function hideProduct360() {
      if (!active) return;
      active = false;
      dragging = false;
      stopAutoplay();
      stage.hidden = true;
      wrapper.classList.remove('mj-product-360--active');
      mainImage.removeAttribute('aria-hidden');
    }

    function showProduct360(button) {
      active = true;
      userInteracted = false;
      wrapper.classList.add('mj-product-360--active');
      mainImage.setAttribute('aria-hidden', 'true');
      stage.hidden = false;
      selectThumbnail(button || trigger);
      showFrame(currentFrame);
      preloadFrames();
      startAutoplay();
    }

    window.mjShowProduct360 = showProduct360;
    window.mjHideProduct360 = hideProduct360;

    stage.addEventListener('pointerdown', function (event) {
      userInteracted = true;
      stopAutoplay();
      dragging = true;
      startX = event.clientX;
      startFrame = currentFrame;
      stage.setPointerCapture(event.pointerId);
    });

    stage.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var pixelsPerFrame = Math.max(6, stage.clientWidth / frameUrls.length / 1.4);
      showFrame(startFrame + Math.round((startX - event.clientX) / pixelsPerFrame));
    });

    function stopDragging() {
      dragging = false;
    }

    stage.addEventListener('pointerup', stopDragging);
    stage.addEventListener('pointercancel', stopDragging);
    stage.addEventListener('lostpointercapture', stopDragging);

    stage.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      userInteracted = true;
      stopAutoplay();
      showFrame(currentFrame + (event.key === 'ArrowLeft' ? -1 : 1));
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        inViewport = entries[0].isIntersecting;
        if (inViewport) startAutoplay();
        else stopAutoplay();
      }, { threshold: 0.2 });
      observer.observe(wrapper);
    }

    var mainImageObserver = new MutationObserver(function (mutations) {
      if (!active) return;
      var sourceChanged = mutations.some(function (mutation) {
        return mutation.attributeName === 'src' || mutation.attributeName === 'srcset';
      });
      if (sourceChanged) hideProduct360();
    });
    mainImageObserver.observe(mainImage, { attributes: true });

    stage.dataset.initialized = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProduct360, { once: true });
  } else {
    initializeProduct360();
  }
})();
